<div id="auth-container" [style.background]="'url(../../../assets/organisation/images/background.png)'">
  <div id="auth-outlet">
    <router-outlet />
  </div>
  @if (application.blocked | async) {
    <div id="blocked-overlay">
      <!-- <mat-icon [tooltip]="'[BLOCKED-TEXT]'">block</mat-icon> -->
    </div>
  }
</div>
